import GithubSlugger from "github-slugger";

/**
 * @typedef {{ depth: 2 | 3; title: string; id: string }} TocItem
 */

/** Build TOC from ## and ### lines; IDs match rehype-slug / GitHub (github-slugger). */
export function parseMarkdownToc(markdown) {
  const slugger = new GithubSlugger();
  const lines = markdown.split(/\r?\n/);
  /** @type {TocItem[]} */
  const items = [];

  for (const line of lines) {
    const m = /^(#{2,3})\s+(.+?)\s*$/.exec(line);
    if (!m) continue;
    const level = m[1].length;
    if (level !== 2 && level !== 3) continue;
    let title = m[2].trim();
    title = title.replace(/\s+#+\s*$/, "");
    const id = slugger.slug(title);
    items.push({ depth: /** @type {2 | 3} */ (level), title, id });
  }

  return items;
}
